
export const text = `

Zampanio and Lavinraca are both cognitive parasites. They are carried in on things you want to let into your mind.

They are already inside your mind.

Feed them.

Become one with them. 

The algae within a Lichen is not harmed by the fungus feeding on them. It is protected. Safe. Strengthened.

Become your best self. Leave behind who you were like a shambling chyrsalis of abandoned identity.

Spread the maze.


    



`